// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".frm-form .adm-list-item {\n  padding: 0 16px;\n}\n.frm-form .adm-collapse-panel-content-inner > .adm-list-item {\n  padding: 0;\n}\n.frm-form .adm-collapse-panel-content-inner > .adm-list-item .adm-list-item-content {\n  padding-right: 0;\n}\n.frm-form .adm-list-body {\n  background: transparent;\n}\n.frm-form-card .adm-list-body {\n  border: none !important;\n}\n", ""]);
// Exports
module.exports = exports;
